import { createAsyncThunk } from '@reduxjs/toolkit';
import { type AppDispatch, type RootState } from '../../../stores/redux/setup';
import {
  type PatientTransfer,
  logger,
  setTransfer,
  removeTransfer,
} from '../patientTransfer.slice';

export const TRANSFER_CONFIRMATION_TIMEOUT_MS = 30_000;

/**
 * Adds a transfer to state and automatically removes it
 * if not confirmed within the timeout window.
 */
export const addTransfer = createAsyncThunk<
  void,
  {
    transfer: PatientTransfer;
    onTrackTransferFailed: (errorMessage: string) => void;
  },
  { state: RootState; dispatch: AppDispatch }
>(
  'patientTransfer/addTransfer',
  ({ transfer, onTrackTransferFailed }, { dispatch, getState }) => {
    dispatch(setTransfer(transfer));

    setTimeout(() => {
      const current = getState().patientTransfer.transfers[transfer.patientId];

      if (current && current.completedAt === undefined) {
        const errorMessage = 'Patient transfer timed out without confirmation';
        logger.warn(errorMessage, {
          patientId: transfer.patientId,
        });
        dispatch(removeTransfer(transfer.patientId));
        onTrackTransferFailed(errorMessage);
      }
    }, TRANSFER_CONFIRMATION_TIMEOUT_MS);
  },
);
